import React from 'react'

import FormReplyLoader from './_load/FormReplyLoader'
import FullPageTemplate from '../../../components/templates/FullPageTemplate'
import Modal from '../../../components/structure/Modal'
import PageContent from './PageContent'

const SuccessfullyExecutedFormPage = ({ shareCode }) => {
  return (
    <FullPageTemplate>
      <Modal open={true} noOverlay>
        <FormReplyLoader shareCode={shareCode}>
          <PageContent />
        </FormReplyLoader>
      </Modal>
    </FullPageTemplate>
  )
}

export default SuccessfullyExecutedFormPage
